import { Box, Typography } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import type { CSSProperties } from 'react';

interface CodeSnippetViewProps {
  title: string;
  value: string;
}

type CodeTypographyTheme = Theme & {
  typography: Theme['typography'] & {
    code?: CSSProperties;
  };
};

const snippetCodeSx = (theme: Theme) => ({
  ...((theme as CodeTypographyTheme).typography.code ?? {}),
  display: 'block',
  fontSize: theme.typography.pxToRem(13),
  lineHeight: 1.45,
  maxWidth: '100%',
  overflow: 'hidden',
  overflowWrap: 'normal' as const,
  whiteSpace: 'pre' as const,
  wordBreak: 'normal' as const,
  WebkitMaskImage: 'linear-gradient(to right, black calc(100% - 1.25rem), transparent)',
  maskImage: 'linear-gradient(to right, black calc(100% - 1.25rem), transparent)',
});

const CodeSnippetView = ({ title, value }: CodeSnippetViewProps) => {
  return (
    <Box id={title} p={1} width={'100%'} minWidth={0}>
      <Typography component="pre" sx={snippetCodeSx}>
        {value}
      </Typography>
    </Box>
  );
};

export default CodeSnippetView;
